// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import exportFromJSON from 'export-from-json';
import { isEmpty, sprintf } from '@automator/utilities';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.log.i18n.actions;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-download-log' )
export class AutomatorLogHeaderActionDownloadLog extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The object that will be sent to the user
	@property( { type: String, attribute: 'recipe-title' } ) accessor recipeTitle;

	@property( { type: Object, attribute: false } ) accessor downloadObject = {};

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ strings.downloadLogEntry }</span>

				<uo-button
					slot="target"
					color="transparent"
					size="small"

					@click=${ this.downloadJSON }
				>
					<uo-icon id="download" size="16"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}

	/**
	 * Downloads the file
	 */
	downloadJSON() {
		if ( isEmpty( this.downloadObject ) ) {
			return;
		}

		// Export the main object
		exportFromJSON( {
			data: this.downloadObject,
			fileName: sprintf( strings.downloadFilename, this.recipeTitle ).replace( /\s/g, '_' ),
			exportType: 'json'
		} );
	}
}